/* Admin: see a partner's Hub password (after the supervisor password) to tell them when they forget it. */
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy, KeyRound, Loader2 } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PwInput } from "@/components/ui/pw-input";

export const SeePassword = ({ code, pid, label }) => {
  const [open, setOpen] = useState(false);
  const [sup, setSup] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const tid = code || pid;
  const close = () => { setOpen(false); setSup(""); setRes(null); };
  const reveal = async () => {
    setBusy(true);
    try {
      const url = code ? `${API}/portal-admin/codes/${encodeURIComponent(code)}/reveal-password` : `${API}/portal-admin/partners/${pid}/reveal-password`;
      const r = await axios.post(url, { password: sup }, { headers: getAuthHeader() });
      setRes(r.data); setSup("");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not show the password"); } finally { setBusy(false); }
  };
  const copy = () => { navigator.clipboard?.writeText(res.password); toast.success("Password copied"); };
  return (
    <>
      <Button size="sm" variant="outline" className="h-7 gap-1 px-2 text-xs" onClick={() => setOpen(true)} title="See password" data-testid={`pa-see-pw-${tid}`}>
        <KeyRound className="h-3.5 w-3.5" />See</Button>
      <Dialog open={open} onOpenChange={(o) => !o && close()}>
        <DialogContent className="max-w-sm" data-testid="pa-see-pw-dialog">
          <DialogHeader><DialogTitle>Password — {label || code}</DialogTitle></DialogHeader>
          {!res ? <div className="space-y-2">
            <p className="text-xs text-slate-500">Enter the supervisor password to see this login's password. Every view is logged.</p>
            <PwInput value={sup} onChange={(e) => setSup(e.target.value)} onKeyDown={(e) => e.key === "Enter" && sup && reveal()} placeholder="Supervisor password" autoComplete="off" autoCapitalize="none" autoCorrect="off" spellCheck={false} className="h-9 w-full rounded-md border px-3 text-sm" data-testid="pa-see-pw-sup" />
            <Button className="w-full" disabled={!sup || busy} onClick={reveal} data-testid="pa-see-pw-show">{busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Show password</Button>
          </div> : <div className="space-y-2">
            <div className="flex items-center gap-2 rounded-lg border bg-slate-50 px-3 py-2">
              <span className="flex-1 select-all font-mono text-base font-semibold" data-testid="pa-see-pw-value">{res.password}</span>
              <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={copy} data-testid="pa-see-pw-copy"><Copy className="h-3.5 w-3.5" />Copy</Button>
            </div>
            {res.set_at && <p className="text-[11px] text-slate-500">Set on {new Date(res.set_at).toLocaleString()}</p>}
          </div>}
        </DialogContent>
      </Dialog>
    </>
  );
};
